import "./InfoButton.css"
import Tooltip from 'src/shared/components/data-display/tooltip/Tooltip'
import IconInfo from "src/shared/icons/infoToolTip"

export const InfoButton = ({ title, description }) => {
    return (
        <Tooltip
            theme="dark"
            title={title}
            description={description}
        >
            <IconInfo />
        </Tooltip>
    )
}